import * as React from 'react';
import { observer } from 'mobx-react';

import Section from 'shared/newComponents/Section';
import Stub from 'shared/newComponents/Stub';
import { useChannelsModalStore } from 'stores/ChannelsModalStore';
import { useChannelsStore } from 'stores';
import { LoadingStage } from 'shared/entities/meta';
import LoaderSpinner from 'shared/newComponents/animations/LoaderSpinner';
import {
  LoaderSpinnerColor,
  LoaderSpinnerSize
} from 'shared/newEntities/components/LoaderSpinner';
import { ComponentType } from 'shared/entities/components/Component';
import { MobileChannelsModalTab } from 'shared/entities/channels';

import Header from './Header';
import ChannelTable from './ChannelTable';

import './Content.modules.scss';

type Props = {
  className?: string;
  footer?: React.ReactNode;
};

const Content: React.FC<Props> = ({ className, footer }) => {
  const channelsStore = useChannelsStore();
  const { store } = useChannelsModalStore();

  const isEmpty = !channelsStore.channels.length;

  const loading =
    channelsStore.channels.loadingStage === LoadingStage.LOADING ||
    channelsStore.channels.loadingStage === LoadingStage.NOT_STARTED;
  const showLoader = store.selectionLoading || (loading && isEmpty);
  const showStub = !showLoader && !loading && isEmpty;
  const showChannelTable = !showLoader && !isEmpty;

  const handleClick = React.useCallback(() => {
    store.selectTab(MobileChannelsModalTab.createChannel);
  }, []);

  const borderedSection = !store.bot;

  return (
    <Section bordered={borderedSection} className={className}>
      <div styleName="container">
        {(!!store.withSections || store.scenario) && (
          <Header styleName="header" />
        )}
        <div styleName="list">
          {showLoader && (
            <LoaderSpinner
              size={LoaderSpinnerSize.sm}
              color={LoaderSpinnerColor.blue}
              centered
            />
          )}
          {showStub && (
            <Stub
              title={(t) =>
                t('ChannelsModal.Content.Stub.title', {
                  ns: 'newContainers'
                })
              }
              description={
                store.bot
                  ? undefined
                  : (t) =>
                      t('ChannelsModal.Content.Stub.description', {
                        ns: 'newContainers'
                      })
              }
              button={
                !store.withSections
                  ? {
                      type: ComponentType.button,
                      onClick: handleClick,
                      children: (t) =>
                        t('ChannelsModal.Content.Stub.button', {
                          ns: 'newContainers'
                        })
                    }
                  : undefined
              }
            />
          )}
          {showChannelTable && <ChannelTable footer={footer} />}
        </div>
      </div>
    </Section>
  );
};

export default observer(Content);
